import styled from "styled-components";
import PlayAreas from "./PlayAreas";
import { useParams } from "react-router-dom";
import { useSakusasPanelGet } from "hooks/sakusas/panel/useSakusasPanelGet";
import { useContext, useEffect } from "react";
import { WsNotifyContext } from "common/ws/WsNotify";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { QUERY_KEYS } from "constant/react_query";

const PlayPanel = () => {
  const { panelSlug } = useParams();
  const panel = useSakusasPanelGet(panelSlug as string, "slug");
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { notifyTime } = useContext(WsNotifyContext);
  useEffect(() => {
    console.log("get info about notify time update - notifyTime", notifyTime);
    invalidateQueriesByKeys([QUERY_KEYS.SAKUSAS_PANEL_GET]);
  }, [notifyTime]);

  return (
    panel &&
    panel.areas && (
      <DivPlayPanel>
        <PlayAreas playAreas={panel.areas} />
      </DivPlayPanel>
    )
  );
};

const DivPlayPanel = styled.div`
  display: grid;
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
  height: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0rem 0rem;
  background-color: DimGrey;

  &&& div {
    overflow: hidden;
  }
`;

export default PlayPanel;
